import { render, staticRenderFns } from "./TabBookMyGroup.vue?vue&type=template&id=6783c16f&"
import script from "./TabBookMyGroup.vue?vue&type=script&lang=js&"
export * from "./TabBookMyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports